"use client";

import { useEffect, useMemo, useState } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

export default function SearchBar() {
  const router = useRouter();
  const pathname = usePathname();
  const sp = useSearchParams();

  const urlQ = useMemo(() => (sp.get("q") ?? "").trim(), [sp]);
  const [query, setQuery] = useState(urlQ);

  useEffect(() => {
    setQuery(urlQ);
  }, [urlQ]);

  function submit() {
    const q = query.trim();
    const params = new URLSearchParams(sp.toString());

    if (q) params.set("q", q);
    else params.delete("q");

    const url = params.toString() ? `/products?${params.toString()}` : "/products";
    if (pathname === "/products") router.replace(url);
    else router.push(url);
  }

  return (
    <div className="flex w-full items-center gap-2">
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") submit();
        }}
        placeholder="Search products…"
        className="h-10 w-full rounded-md border px-3 text-sm outline-none transition
                   border-neutral-200 bg-white text-neutral-900 placeholder:text-neutral-400
                   focus:ring-2 focus:ring-neutral-900/20
                   dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-100 dark:placeholder:text-neutral-500
                   dark:focus:ring-neutral-100/20"
      />
      <button
        type="button"
        onClick={submit}
        className="h-10 rounded-md px-3 text-sm font-medium shadow-sm transition
                   bg-neutral-900 text-white hover:bg-neutral-800
                   dark:bg-neutral-100 dark:text-neutral-900 dark:hover:bg-neutral-200"
      >
        Search
      </button>
    </div>
  );
}
